const apiEndpoint =
  window.location.host.includes('localhost') || window.location.host.includes('staging')
    ? process.env.REACT_APP_API_ENDPOINT_STAGING
    : process.env.REACT_APP_API_ENDPOINT_PRODUCTION;

export default apiEndpoint;
